import React, { useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import { useTranslation } from 'react-i18next';

import Seo from '../components/Seo';

import '../style/mentionsLegales.css';

// Page "Mentions légales" (obligation légale France Num, accessible depuis le
// footer sur toutes les pages). Le contenu juridique est en français, conforme
// au droit français, et volontairement rendu tel quel plutôt que via i18n.
function MentionsLegales() {
  const { t } = useTranslation();

  // On arrive ici via un lien du footer (souvent en bas de page) : on remonte
  // en haut au montage pour afficher la page depuis son titre. Le conteneur de
  // scroll réel est <body> (App.css lui donne height:100vh + overflow), donc on
  // le remet à zéro en plus de window pour couvrir tous les cas.
  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }, []);

  return (
    <div className="legal-page">
      <Seo
        path="/mentions-legales"
        title={t('seo.mentionsLegales.title')}
        description={t('seo.mentionsLegales.description')}
      />
      <main>
        <Container className="legal-container">
          <h1 className="legal-title">Mentions légales</h1>

          <section className="legal-section">
            <h2 className="section-title">Édition du site</h2>
            <p>Le site kalia-tech.com est édité par :</p>
            <p>
              <strong>KALIA</strong>, société par actions simplifiée (SAS) au capital social de 1 000 €<br />
              Siège social : 60 rue François 1er, 75008 Paris, France<br />
              Immatriculée au RCS de Paris sous le numéro 943 961 219<br />
              SIREN : 943 961 219 — SIRET (siège) : 943 961 219 00012<br />
              N° de TVA intracommunautaire : FR00943961219
            </p>
            <p>Directeur de la publication : Roni Chauvart, Président</p>
            <p>
              Contact : <a href="mailto:contact@kalia-tech.com">contact@kalia-tech.com</a>
            </p>
          </section>

          <section className="legal-section">
            <h2 className="section-title">Hébergement</h2>
            <p>Le site est hébergé par :</p>
            <p>
              Amazon Web Services EMEA SARL<br />
              38 avenue John F. Kennedy, L-1855 Luxembourg
            </p>
          </section>

          <section className="legal-section">
            <h2 className="section-title">Propriété intellectuelle</h2>
            <p>
              L'ensemble des éléments présents sur le site kalia-tech.com (textes, graphismes, logos,
              icônes, images, structure, logiciels) est la propriété exclusive de KALIA, sauf mention
              contraire, et est protégé par les lois françaises et internationales relatives à la
              propriété intellectuelle. Toute reproduction, représentation, modification, publication ou
              adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé
              utilisé, est interdite sans l'autorisation écrite préalable de KALIA.
            </p>
          </section>

          <section className="legal-section">
            <h2 className="section-title">Protection des données personnelles</h2>
            <p>
              Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi
              Informatique et Libertés du 6 janvier 1978 modifiée, KALIA s'engage à protéger la vie
              privée des utilisateurs du site.
            </p>
            <p>
              <strong>Responsable du traitement</strong> : KALIA, représentée par Roni Chauvart.
            </p>
            <p>
              <strong>Données collectées</strong> : les données personnelles collectées via le site
              (notamment via le formulaire de contact) sont celles strictement nécessaires pour répondre
              à votre demande : nom, prénom, adresse email, et le cas échéant les informations que vous
              choisissez de communiquer dans votre message.
            </p>
            <p>
              <strong>Finalité</strong> : ces données sont utilisées uniquement pour traiter votre
              demande de contact et échanger avec vous dans le cadre d'une relation commerciale
              potentielle ou en cours. Elles ne sont ni cédées, ni vendues à des tiers.
            </p>
            <p>
              <strong>Durée de conservation</strong> : les données sont conservées pendant la durée
              nécessaire à la gestion de la relation commerciale, et au maximum 3 ans après le dernier
              contact en l'absence de relation contractuelle.
            </p>
            <p>
              <strong>Vos droits</strong> : conformément à la réglementation applicable, vous disposez
              d'un droit d'accès, de rectification, d'effacement, de limitation, d'opposition et de
              portabilité de vos données personnelles. Vous pouvez exercer ces droits en écrivant à{' '}
              <a href="mailto:contact@kalia-tech.com">contact@kalia-tech.com</a>.
            </p>
            <p>
              <strong>Réclamation</strong> : vous disposez également du droit d'introduire une
              réclamation auprès de la CNIL (Commission Nationale de l'Informatique et des Libertés —{' '}
              <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer">www.cnil.fr</a>).
            </p>
          </section>

          <section className="legal-section">
            <h2 className="section-title">Limitation de responsabilité</h2>
            <p>
              KALIA s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur ce
              site, mais ne peut garantir l'exhaustivité ou l'absence de modification par des tiers.
              KALIA ne pourra être tenue responsable des dommages directs ou indirects résultant de
              l'accès ou de l'utilisation du site, y compris l'inaccessibilité, les pertes de données, ou
              la présence de virus.
            </p>
          </section>

          <section className="legal-section">
            <h2 className="section-title">Droit applicable</h2>
            <p>
              Les présentes mentions légales sont soumises au droit français. En cas de litige, et à
              défaut de résolution amiable, les tribunaux français seront seuls compétents.
            </p>
          </section>

          <p className="legal-updated">
            <em>Dernière mise à jour : 12 août 2026</em>
          </p>
        </Container>
      </main>
    </div>
  );
}

export default MentionsLegales;
